/**
 * Gallery review slider: Swiper for nested CMS slides + scroll-to-reviews on summary.
 */
(function () {
    function loadSwiper() {
      if (window.Swiper) return Promise.resolve();
      if (window.__d2cSwiperLoading) return window.__d2cSwiperLoading;
      window.__d2cSwiperLoading = new Promise(function (resolve, reject) {
        var href = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css';
        if (!document.querySelector('link[href*="swiper-bundle.min.css"]')) {
          var css = document.createElement('link');
          css.rel = 'stylesheet';
          css.href = href;
          document.head.appendChild(css);
        }
        var s = document.createElement('script');
        s.src = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js';
        s.async = true;
        s.onload = function () {
          resolve();
        };
        s.onerror = function () {
          reject(new Error('Swiper load failed'));
        };
        document.head.appendChild(s);
      });
      return window.__d2cSwiperLoading;
    }
  
    function unwrapShopifySlideWrappers(wrapper) {
      var shopifyBlocks = wrapper.querySelectorAll(':scope > .shopify-block');
      shopifyBlocks.forEach(function (wb) {
        var slide = wb.querySelector(':scope > .swiper-slide');
        if (slide && wb.parentNode === wrapper) {
          wrapper.insertBefore(slide, wb);
          wb.remove();
        }
      });
    }
  
    function initSwiper(root) {
      var el = root.querySelector('.d2c-gallery-judgeme-reviews__swiper');
      var pag = root.querySelector('.d2c-gallery-judgeme-reviews__pagination');
      if (!el || !window.Swiper) return;
      var wrapper = el.querySelector('.swiper-wrapper');
      if (wrapper && wrapper.querySelector(':scope > .shopify-block')) {
        unwrapShopifySlideWrappers(wrapper);
      }
      var slides = el.querySelectorAll('.swiper-slide');
      if (slides.length === 0) return;
      if (root.__d2cSwiperInstance) {
        try {
          root.__d2cSwiperInstance.destroy(true, true);
        } catch (e) {}
      }
      var slideCount = slides.length;
      var mobileSlidesPerView = slideCount > 1 ? 1.2 : 1;
      var pagOpts = {
        el: pag,
        clickable: true,
        bulletClass: 'd2c-gallery-judgeme-reviews__bullet',
        bulletActiveClass: 'd2c-gallery-judgeme-reviews__bullet--active',
      };
      root.__d2cSwiperInstance = new window.Swiper(el, {
        speed: 400,
        autoHeight: true,
        grabCursor: true,
        watchOverflow: true,
        observer: true,
        observeSlideChildren: true,
        observeParents: true,
        slidesPerView: mobileSlidesPerView,
        spaceBetween: 10,
        loop: false,
        pagination: Object.assign({ enabled: false }, pagOpts),
        breakpoints: {
          750: {
            slidesPerView: 1,
            spaceBetween: 10,
            loop: false,
            pagination: Object.assign({ enabled: slideCount > 1 }, pagOpts),
          },
        },
        on: {
          slideChangeTransitionEnd: function () {
            try {
              this.updateAutoHeight(this.params.speed);
            } catch (e) {}
          },
        },
      });
  
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          try {
            if (root.__d2cSwiperInstance) {
              root.__d2cSwiperInstance.update();
              root.__d2cSwiperInstance.updateAutoHeight(0);
            }
          } catch (e) {}
          root.classList.add('d2c-gallery-judgeme-reviews--swiper-ready');
        });
      });
  
      if (!root.dataset.d2cGjResizeBound) {
        root.dataset.d2cGjResizeBound = '1';
        var resizeTimer;
        window.addEventListener('resize', function () {
          clearTimeout(resizeTimer);
          resizeTimer = setTimeout(function () {
            var sw = root.__d2cSwiperInstance;
            if (sw && typeof sw.update === 'function') {
              try {
                sw.update();
                if (typeof sw.updateAutoHeight === 'function') sw.updateAutoHeight(0);
              } catch (e) {}
            }
          }, 120);
        });
      }
    }
  
    function scrollToReviews(sel) {
      if (!sel) return;
      var id = sel.replace(/^#/, '');
      var node = document.getElementById(id) || document.querySelector(sel);
      if (node) {
        node.scrollIntoView({ behavior: 'smooth', block: 'start' });
        try {
          history.replaceState(null, '', '#' + id);
        } catch (e) {}
      }
    }
  
    function bindScrollCta(root) {
      if (root.dataset.d2cGjCtaBound === '1') return;
      var cta = root.querySelector('[data-d2c-judgeme-scroll-reviews]');
      if (!cta) return;
      root.dataset.d2cGjCtaBound = '1';
      cta.addEventListener('click', function (e) {
        if (e) {
          e.preventDefault();
          e.stopPropagation();
        }
        scrollToReviews('#d2c-product-reviews');
      });
    }

    function run(root) {
      bindScrollCta(root);

      var swiperHost = root.querySelector('.d2c-gallery-judgeme-reviews__swiper');
      if (!swiperHost) return;
      if (swiperHost.querySelectorAll('.swiper-slide').length === 0) return;

      loadSwiper()
        .then(function () {
          initSwiper(root);
        })
        .catch(function () {
          root.classList.add('d2c-gallery-judgeme-reviews--swiper-ready');
        });
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('[data-d2c-gallery-judgeme-reviews]').forEach(run);
    }

    function refreshSwiper(root) {
      if (!root) return;
      loadSwiper()
        .then(function () {
          initSwiper(root);
        })
        .catch(function () {});
    }

    initAll();

    if (typeof Shopify !== 'undefined' && Shopify.designMode) {
      document.addEventListener('shopify:section:load', function (event) {
        initAll(event.target);
      });

      document.addEventListener('shopify:block:select', function (event) {
        var root = event.target.closest('[data-d2c-gallery-judgeme-reviews]');
        if (root) refreshSwiper(root);
      });
    }
  })();
  